export const componentGridStyle = {
  margin: '15px 0px',
  padding: '0px 29px',
};

export const toolTipChildStyle = {
  marginRight: '-2px',
};
